import {
  CheckboxFilter,
  CheckboxProps,
  DateFromFilter,
  DateProps,
  DateToFilter,
  Filter as FilterModel,
  NumberFromFilter,
  NumberProps,
  NumberToFilter,
  OnOffCheckboxFilter,
  OnOffCheckboxProps,
  RangeFilter,
  RangeProps,
  SelectFilter,
  SelectProps,
  StringFilter,
  StringProps,
  DateFilter,
  InternalStringFilter,
  InternalStringProps,
  DateRangeFilter,
  DateRangeProps,
} from '../ApiViewModels'

export const FilterTypes: FilterModel = {
  checkbox: ({ value, toFilter }: CheckboxProps): CheckboxFilter => ({
    type: 'checkbox',
    value,
    toFilter,
  }),

  string: ({ value }: StringProps): StringFilter => ({
    type: 'string',
    value,
  }),

  range: ({ min, max, value, marks, valueLabelFormat, minLabel, maxLabel }: RangeProps): RangeFilter => ({
    type: 'range',
    min,
    max,
    value,
    marks,
    valueLabelFormat,
    minLabel,
    maxLabel,
  }),

  onOffCheckbox: ({ value, icons, tooltips, mapping }: OnOffCheckboxProps): OnOffCheckboxFilter => ({
    type: 'onOffCheckbox',
    value,
    icons,
    tooltips,
    mapping,
  }),

  date: ({ value }: DateProps): DateFilter => ({
    value,
    type: 'date',
  }),

  dateFrom: ({ value }: DateProps): DateFromFilter => ({
    type: 'dateFrom',
    value,
  }),

  dateTo: ({ value }: DateProps): DateToFilter => ({
    type: 'dateTo',
    value,
  }),

  dateRange: ({ value }: DateRangeProps): DateRangeFilter => ({
    type: 'dateRange',
    value,
  }),

  select: ({ value, options, clearable }: SelectProps): SelectFilter => ({
    type: 'select',
    options,
    clearable,
    value,
  }),

  numberFrom: ({ value, min, max, resetValue }: NumberProps): NumberFromFilter => ({
    type: 'numberFrom',
    min,
    max,
    resetValue,
    value,
  }),

  numberTo: ({ value, min, max, resetValue }: NumberProps): NumberToFilter => ({
    type: 'numberTo',
    min,
    max,
    resetValue,
    value,
  }),

  internal: ({ filterFunction, value }: InternalStringProps): InternalStringFilter => ({
    type: 'internal',
    filterFunction,
    value,
  }),
}
